import {getServerTexts as getTexts, initTexts, texts as text} from '../../../Localization/texts';

const entity = 'UI_NEWANNOUNCE';

const he = {
    finalStep: 'סיום',
    okBtn: 'ספרו לי עוד',
    cancelBtn: 'לא תודה',
    nextBtn: 'להמשיך',
    backBtn: 'חזרה',
    showMe: 'ספרו לי עוד',
    closeTooltip: 'סגירה',
    //24.1
    formDesignTitle: 'חווייה חדשה של עיצוב מסך',
    formDesignText: 'מעכשיו תוכלו להתאים אישית מסכים במהירות גם ע"י גרירת שדות ובחירה מרובה.',
    partDialogTitle: 'בחירת מוצרים מהירה ומדוייקת מקטלוג',
    partDialogText: 'בחרו מקטלוג כמה מוצרים בו זמנית. בדקו את יתרות המלאי ועדכנו כמויות.',
    bpmTitle: 'ניהול תהליכים (BPM) - חוויית משתמש מתקדמת ואינטואיטיבית',
    bpmText: 'צרו תרשים BPM בצורה קלה ונוחה. שילחו אימיילים אוטומטית לכמה מכותבים בו זמנית.',
    chartTitle: 'תרשימים ב- Priority Analytics (Visualization)',
    chartText: 'בחרו תרשים מספריית תרשימים מגוונת להצגת נתונים  בצורה ויזואלית ואטרקטיבית.',
    EOYTitle: 'תהליך יעודי ומהיר למעבר שנה',
    EOYText: 'השתמשו בתהליך מעבר שנה שמוביל אתכם צעד אחר צעד, בקלות ובמהירות לשנת הכספים החדשה.',
    // 25.0
    newHomepageTitle: 'דף הבית החדש מחכה לכם ',
    newHomepageText: `עכשיו עם שני אזורים נפרדים: אחד לתובנות (פורטלטים ווידג'טים), ואחד לקיצורי הדרך.\nתוכלו ליצור קבוצות קיצורי דרך מותאמות אישית.`,
    automationTitle: 'גלו את יכולות aiERP באוטומציות שלכם',
    automationText:
        'צרו חוקים עסקיים ותהליכי BPM בקלות. פשוט תארו את החוק במילים שלכם ותנו ל- aiERP לעשות את השאר.',
    AIAdvSearchesTitle: 'חיפוש מתקדם בעזרת aiERP',
    AIAdvSearchesText:
        'פשוט רשמו את מה שתרצו למצוא במילים שלכם וקבלו תוצאות. כבר לא צריך להגדיר תנאים ולבחור שדות - תנו ל- aiERP לעשות זאת עבורכם.',
    emailEditorTitle: 'חווייה חדשה לעריכת אימיילים',
    emailEditorText:
        'צרו אימיילים מקצועיים  בתהליכי BPM ובחוקי אוטומציה - עם עורך אימיילים חדש משולב AI.\nהשתמשו בתכונות החכמות של aiERP: שפרו את סגנון הכתיבה עם תיקונים חכמים, תוך הוספת תוכן דינמי, עיצוב עשיר ואלמנטים חזותיים.',
    ADPTitle: 'חווייה חדשה של תכנון הפצה מתקדם (ADP)',
    ADPText:
        'ממשק ויזואלי חדש לניהול כל שלב בתהליך תכנון המשלוחים - מקצה לקצה, שהופך את ניהול המשלוחים ליעיל ואפקטיבי יותר מאי פעם. (מודול בתשלום)',
    // 25.01
    welcomePageTitle: 'גלו את החידושים שמחכים לכם בפריוריטי, עם יכולות AI',
    welcomePageText: 'יכולות חדשות ומתקדמות בעיצוב רענן לחוויית שימוש מהירה, חכמה, וקלה יותר.',
    AIinChartsTitle: 'ניתוח תרשימים חכם בעזרת AI',
    AIinChartsText:
        'תובנות חכמות שעוזרות לך לנתח את התרשים. Priority Analytics משנה את האופן שבו אתם מנתחים ומבינים את הנתונים העסקיים שלכם.',
    optimizationTitle: ' אופטימיזציית מסלולים  מבוססת AI',
    optimizationText:
        'תכנון מסלולים אופטימלי המופעל בעזרת AI שעוזר למתכנן ההפצה ליצור מסלולים יעילים ולחסוך זמן נסיעה ועלויות דלק.',
    newEmailTitle: 'חוויית עריכת אימיילים מתקדמת',
    newEmailText:
        "צרו אימיילים מקצועיים עם העורך החדש והעוצמתי שלנו, כולל יכולות AI למציאת הטון המדוייק, עיצוב טקסט מתקדם, הוספת תמונות ואימוג'ים.",
    serviceFieldAppTitle: 'הכירו את אפליקציית טכנאי שטח',
    serviceFieldAppText:
        'אפליקציה יעודית לטכנאים שמאפשרת גישה מלאה  לקריאת השירות, ניפוק חלפים בזמן אמת, דיווח שעות, ניווט ליעד, וחתימה דיגיטלית.',
    upcomingUpgrade: 'גרסת Priority החדשה בדרך',
    upgradeDetails: 'מערכת Priority עומדת להשתדרג לגרסה <P1>.\nמועד השדרוג נקבע ל <P2> בשעה <P3>.',
    prepareTitle: 'הכנה לשדרוג:',
    firstBullet:
        'הקמנו סביבת בדיקה זמנית ייעודית שתאפשר לכם להכיר את הגרסה החדשה ולהיערך בהתאם. הסביבה זמינה בכתובת:',
    secondBullet:
        'כל התכונות החדשות והשיפורים שהוטמעו בגרסה זו מפורטים <L> <L>. מומלץ לעיין ברשימה כדי להכיר את השינויים ולהיערך אליהם כראוי.',
    secondBulletP1: 'כל התכונות החדשות והשיפורים שהוטמעו בגרסה זו מפורטים',
    releaseNotes: 'ברשימת החידושים',
    secondBulletP2: 'מומלץ לעיין ברשימה כדי להכיר את השינויים ולהיערך אליהם כראוי.',
    finalNote:
        'לתשומת לבכם, שלחנו הודעת אימייל לגבי השדרוג לאיש הקשר הראשי, ולאנשי הקשר לגבייה ושירות  שרשומים אצלינו. אם לא קיבלתם את ההודעה או שיש לכם שאלות לגבי השדרוג, אתם מוזמנים לפנות אלינו בכתובת',
    next: 'הבא',
    stayUpdated: ' הישארו מעודכנים',
    personalizedUpdates: 'קבלו עדכונים מותאמים אישית בנושאים שחשובים לכם.',
    topicsTitle: 'סמנו את הנושאים הרלוונטיים:',
    byClicking: 'בלחיצה על הכפתור',
    termsAndConditionsStart:
        ', הינך מסכים/ה לכך שפריוריטי תאסוף את כתובת הדוא״ל שלך, ובמידה שסיפקת – גם את מספר הטלפון שלך, לצורך שליחת עדכוני שיווק הכוללים הודעות דוא״ל, מסרונים ו/או שיחות טלפון (אשר עשויות להתבצע באמצעות מערכת חיוג אוטומטי) בנוגע לנושאים שבחרת, הצעות, חדשות, אירועים ותכנים נוספים שלדעת פריוריטי  עשויים לעניין אותך. באפשרותך לבטל את הסכמתך בכל עת על ידי לחיצה על “הסר מרשימת התפוצה” בהודעת דוא״ל, שליחת תשובת "הסר" בהודעת טקסט, או פנייה ישירה אלינו. למידע נוסף על אופן הטיפול בזכויות הפרטיות שלך, ראה/י את',
    privacyPolicy: 'מדיניות הפרטיות',
    termsAndConditionsEnd: 'שלנו.',
    accept: 'שלחו לי עדכונים',
    decline: 'לא, תודה'
};

const en = {
    finalStep: 'Done',
    cancelBtn: 'No, thank you',
    nextBtn: 'Next',
    backBtn: 'Back',
    showMe: 'Show me',
    closeTooltip: 'Close',
    //24.1
    formDesignTitle: 'Form Design',
    formDesignText: 'Personalize your forms faster with drag & drop and multi-select options.',
    partDialogTitle: 'Choose parts quicker',
    partDialogText:
        'Open the extended view to see pictures, check availability, select quantity, straight from the parts list.',
    bpmTitle: 'Enhanced BPM flow chart experience with a fresh look',
    bpmText: 'Create BPM flow charts efficiently. Automate emails to multiple recipients.',
    chartTitle: 'Visualize your data in Priority Analytics',
    chartText:
        'Choose from a chart library to show your data in a personalized, visually attractive report.',
    EOYTitle: 'Closing the year has never been easier',
    EOYText:
        'Go step-by-step through the year-end process, ensuring a smooth transition to the new fiscal year.',
    // 25.0
    newHomepageTitle: 'Your new home page awaits',
    newHomepageText:
        'Now split into two distinct areas: one for insights (portlets & widgets) and one for quick access to your most-used shortcuts.\nGroup your homepage shortcuts to fit your needs.',
    automationTitle: 'Automations Powered by aiERP',
    automationText:
        'Create BPM and Automation rules easily - write the rule in your own words and let aiERP set up everything for you.',
    AIAdvSearchesTitle: 'Advanced Search Powered by aiERP',
    AIAdvSearchesText:
        'Describe what you need in your own words and let aiERP find it for you. No more manual conditions or field selections - just type and get results.',
    emailEditorTitle: 'New Email Editing Experience',
    emailEditorText:
        "Create professional emails directly in your BPM and Automation Rules - with our newly integrated AI-powered editor.\nUse aiERP's intelligent features: Perfect your writing with smart refinements while adding dynamic content, rich formatting, and eye-catching visuals.",
    ADPTitle: 'New Advanced Delivery Planning Experience',
    ADPText:
        'Guides you through the whole delivery planning process from start to finish, making delivery management easier than ever. (Requires purchase)',
    // 25.01
    welcomePageTitle:
        'Discover a new level of efficiency in your Priority experience, with AI capabilities',
    welcomePageText:
        'Innovative capabilities and a fresh design, to elevate your business with transformative solutions.',
    AIinChartsTitle: 'AI-Powered Chart Analysis',
    AIinChartsText:
        'Intelligent chart insights transform how you analyze and communicate your data. Priority Analytics now creates clear, contextual analyses for your charts.',
    optimizationTitle: 'AI-Powered Route Optimization',
    optimizationText:
        'Automated route optimization powered by AI to help dispatchers create the most efficient routes for drivers, reducing travel time & fuel costs.',
    newEmailTitle: 'New Email Composer Experience',
    newEmailText:
        'New experience powered by AI that nails the perfect tone, polishes your message, and gets things done faster. Create professional emails with our powerful editor, complete with formatting, images, and emojis.',
    serviceFieldAppTitle: 'Introducing the Field Service App',
    serviceFieldAppText:
        'Built for the field, designed for efficiency. The complete toolkit for field service technicians in one powerful app. Detailed service call information, part issue tracking, time reporting, map navigation, and digital signatures. ',
    upcomingUpgrade: 'Priority version upgrade coming soon',
    upgradeDetails: 'Your Priority system will be upgraded to version <P1> on <P2> at <P3> GMT.',
    prepareTitle: 'Prepare for the upgrade:',
    firstBullet: 'Test the new version in your temporary test environment:',
    secondBulletP1: 'Review all updates in the',
    releaseNotes: 'Release Notes',
    secondBulletP2: "- see what's new and what we've enhanced in this version.",
    finalNote:
        'We sent an email regarding this upgrade to the billing contact, the service contact, and the additional main contact we have on record.\nIf you did not receive this email, or have any additional questions, reach out to us at:',
    next: 'Next',
    stayUpdated: 'Stay updated',
    personalizedUpdates: 'Get personalized updates on topics that matter to you.',
    topicsTitle: 'Mark the relevant topics:',
    byClicking: 'By clicking',
    termsAndConditionsStart:
        'you consent to Priority collecting your email address and, if provided, your phone number to send you marketing communications, including emails, text messages and/or phone calls (which may involve using an automated dialling system) about your chosen topics, offers, news, and events and other content that Priority believes may interest you. You can opt out anytime by clicking “Unsubscribe” in an email, replying “STOP” to a text, or contacting us directly. See our',
    privacyPolicy: 'Privacy Policy',
    termsAndConditionsEnd: 'for more details on how we handle your privacy rights.',
    accept: 'Send me updates',
    decline: 'No, thank you'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    //24.1
    36: 'finalStep',
    101: 'closeTooltip',
    104: 'cancelBtn',
    105: 'ShowMe',
    106: 'formDesignTitle',
    107: 'formDesignText',
    156: 'nextBtn',
    109: 'backBtn',
    110: 'partDialogTitle',
    111: 'partDialogText',
    112: 'bpmTitle',
    113: 'bpmText',
    114: 'chartTitle',
    115: 'chartText',
    116: 'EOYTitle',
    117: 'EOYText',
    // 25.0
    118: 'newHomepageTitle',
    119: 'newHomepageText',
    120: 'automationTitle',
    121: 'automationText',
    122: 'AIAdvSearchesTitle',
    123: 'AIAdvSearchesText',
    124: 'emailEditorTitle',
    125: 'emailEditorText',
    126: 'ADPTitle',
    127: 'ADPText',
    // 25.01
    146: 'welcomePageTitle',
    147: 'welcomePageText',
    148: 'AIinChartsTitle',
    149: 'AIinChartsText',
    150: 'optimizationTitle',
    151: 'optimizationText',
    152: 'newEmailTitle',
    153: 'newEmailText',
    154: 'serviceFieldAppTitle',
    155: 'serviceFieldAppText',
    // Upgrade Dialog
    133: 'next',
    136: 'label1',
    137: 'label2',
    138: 'label3',
    139: 'label4',
    140: 'label5',
    141: 'label6'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

initTexts(entity, fallbacks);

export const texts = text[entity];
